import { VStack } from "@chakra-ui/react";
import { useHistory, useRouteMatch } from "react-router-dom";

import { useGetGroups } from "modules/groups/infrastructure/useGetGroups";

import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";

import { ChakraText } from "components/ChakraText";
import { SideDrawerLink } from "./SideDrawerLink";

interface IProps {
  onCloseDrawer: () => void;
}

const MobileGroups = ({ onCloseDrawer }: IProps) => {
  const { data: groups } = useGetGroups();
  const { friendlyUrl } = useGetFriendlyUrl();
  const match = useRouteMatch<{
    groupId: string;
  }>({
    path: "/e-rezerwacja/:friendlyUrl/:groupId?",
  });
  const history = useHistory();
  const groupId = match?.params.groupId;

  if (!groups) {
    return <></>;
  }
  return (
    <VStack spacing={4} alignItems="baseline">
      {groups.map((group) => {
        const isDisabled = group.id.toString() === groupId;
        return (
          <SideDrawerLink
            isDisabled={isDisabled}
            key={group.id}
            onClick={() => {
              history.push(`/e-rezerwacja/${friendlyUrl}/${group.id}`);
              !isDisabled && onCloseDrawer();
            }}
          >
            <ChakraText>{group.name}</ChakraText>
          </SideDrawerLink>
        );
      })}
    </VStack>
  );
};

export { MobileGroups };
